<i18n>
{
  "cl": {
    "home": "Inicio",
    "title": "Evaluaciones automáticas"
  }
}
</i18n>
<template>
  <div class="columns">
    <div class="column">
      <b-breadcrumb
        size="is-small">
        <b-breadcrumb-item
          tag="router-link"
          to="/">
          {{ $t('home') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item
          tag="router-link"
          :to="{ name: 'evaluations' }">
          {{ $t('title') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item
          v-for="link in links"
          :key="link.label"
          tag="router-link"
          :to="link.to"
          :active="link.active">
          {{ link.label }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationBreadcrumb',
  props: {
    links: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
